import type { ProductCreateRequest } from '@shared/types/product';

export interface ValidationIssue {
  field: keyof ProductCreateRequest | 'form';
  message: string;
}

export function validateProductCreate(input: ProductCreateRequest): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  if (!input.name || input.name.trim().length === 0) {
    issues.push({ field: 'name', message: 'ソリューション名は必須です' });
  }
  return issues;
}
